<template>
  <el-link type="primary" @click="goDetail" :title="`${order.customer_name||''}`">
    {{ order[field] }}
  </el-link>
</template>

<script>
import {judgeOrderWholeCase} from "../index";
import {pidWithMark} from "@/api/adOrder";
import {pidWithPukeOrder} from "@/api/regulars";

/**
 * 跳转订单详情
 */
export default {
  name: "ToDetail",
  props: {
    order: {
      type: Object,
      required: true
    },
    byField: {
      type: String,
      default: 'id'
    },
    field: {
      type: String,
      default: 'order_no'
    },
    routerType: {
      type: String,
      default: 'wcm'
    },
    pt: Number,
  },
  methods: {
    async goDetail() {
      // 普通订单
      let name = 'editAdOrder';
      let model = ''
      if (this.routerType === 'puke') {
        model = await pidWithPukeOrder({[this.byField]: this.order[this.byField]})
        name = 'editAdOrderRegulars'
      } else {
        model = await pidWithMark({[this.byField]: this.order[this.byField]})
      }
      if (!model) {
        this.$message.warning('订单信息不存在！');
        return false
      }
      const isWcmMain = judgeOrderWholeCase(model.model, 'main');


      if (isWcmMain) {
        // 全案营销订单
        name = 'editAdOrderWcm'
      }
      const {href} = this.$router.resolve({
        name: name,
        query: {pt: this.pt},
        params: {id: model.model.id},
      });
      window.open(href, "_blank");
    },
  }
}
</script>

<style scoped>

</style>
